import React from 'react';

import { StaticReactDataTable } from '@metarouter-private/mr-mui';

import useSchemaEnforcementTable from './useSchemaEnforcementTable';

export default function SchemaEnforcementTable() {
  const props = useSchemaEnforcementTable();
  return <StaticReactDataTable {...props} />;
}
